export default __webpack_public_path__ + "images/defaultAvatar.8afcdfaf7cf417f8ddba2c23dcca1136.jpg";